import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Mascot } from '@/components/Mascot';
import { Star } from 'lucide-react';

interface AppReviewPromptDialogProps {
  open: boolean;
  /** Fires for X-close (backdrop dismiss is disabled per app dialog standard). */
  onDismiss: () => void;
  onAccept: () => void;
  onDecline: () => void;
}

export function AppReviewPromptDialog({ open, onDismiss, onAccept, onDecline }: AppReviewPromptDialogProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) onDismiss();
      }}
    >
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="text-center space-y-2">
          {/* Five-star arch: solid honey-gold stars crowning the mascot.
              Negative bottom margin sinks the arc into the mascot PNG's
              transparent headroom so it visually crowns the cup rim. */}
          <div className="flex justify-center items-end gap-1 -mb-6" aria-hidden="true">
            <Star className="h-4 w-4 text-honey fill-current translate-y-1.5" />
            <Star className="h-4 w-4 text-honey fill-current translate-y-0.5" />
            <Star className="h-5 w-5 text-honey fill-current -translate-y-1" />
            <Star className="h-4 w-4 text-honey fill-current translate-y-0.5" />
            <Star className="h-4 w-4 text-honey fill-current translate-y-1.5" />
          </div>
          <div className="flex justify-center -mb-4">
            <Mascot mood="happy" size="lg" />
          </div>
          <DialogTitle className="text-xl font-display">Enjoying Grounded?</DialogTitle>
          <DialogDescription className="text-base">
            If Grounded's helped you find a good spot to work, a quick App Store review means a lot.
          </DialogDescription>
        </DialogHeader>

        <div className="flex flex-col gap-3 mt-4">
          <Button onClick={onAccept} className="w-full" size="lg">
            Rate Grounded
          </Button>
          <Button variant="ghost" onClick={onDecline} className="w-full text-muted-foreground">
            Not really
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
